module.exports = __webpack_public_path__ + "static/img/bg9.2e9c726f.png";